<template>
  <div>
    <container-headline
      :headline="$t('global.contactpersondetails')"
      :col="6"
    ></container-headline>

    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="col-xl-12" v-if="kontaktperson.id">
            <div class="row">
              <div class="col-xl-6">
                <single-select-person
                  id="person"
                  :person="person"
                  :label="$t('global.person')"
                  :allowOpen="true"
                  :editable="true"
                  :required="false"
                  @confirmed="setPerson"
                />
              </div>
            </div>
            <div class="row" v-if="false">
              <div class="col-xl-6">
                <div class="form-group">
                  <input
                    v-model.trim="kontaktperson.vorname"
                    class="form-control"
                    placeholder=" "
                    :readonly="!editable"
                    :disabled="true"
                  />
                  <label>{{ $t("global.firstname") }}</label>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="form-group">
                  <input
                    v-model.trim="kontaktperson.name"
                    class="form-control"
                    placeholder=" "
                    :readonly="!editable"
                    :disabled="true"
                  />
                  <label>{{ $t("global.surname") }}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-xl-3">
                <input
                  v-model.trim="kontaktperson.strasseNr"
                  type="text"
                  class="form-control"
                  placeholder=" "
                  :disabled="true"
                />
                <label>{{ $t("global.streetandhousenumber") }}</label>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <input
                    v-model.trim="kontaktperson.plz"
                    type="text"
                    class="form-control"
                    placeholder=" "
                    :disabled="true"
                  />
                  <label>{{ $t("global.zipcode") }}</label>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <input
                    v-model.trim="kontaktperson.ort"
                    type="text"
                    class="form-control"
                    placeholder=" "
                    :disabled="true"
                  />
                  <label>{{ $t("global.city") }}</label>
                </div>
              </div>
              <div class="form-group col-xl-3">
                <v-select
                  v-model.trim="kontaktperson.land.id"
                  :options="laender"
                  label="name"
                  :placeholder="$t('global.country')"
                  :clearable="false"
                  :disabled="true"
                  :reduce="country => country.id"
                ></v-select>
                <label>{{ $t("global.country") }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4">
                <div class="form-group d-flex align-items-center pos-r">
                  <label>{{ $t("global.privatephone") }}</label>
                  <div class="input-wrapper d-flex align-items-center pos-r">
                    <vue-tel-input
                      class="phone-input padding-right-35px"
                      id="phone-private"
                      v-model="kontaktperson.telefonP"
                      :disabled="true"
                      :inputOptions="inputOptions"
                      mode="international"
                    ></vue-tel-input>
                    <div
                      class="call-button pos-a top-0 right-0 bottom-0 d-flex padding-x-10px clickable hover-success"
                      @click="call(kontaktperson.telefonP)"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-phone-arrow-up-right"
                        class="m-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group d-flex align-items-center pos-r">
                  <label>{{ $t("global.mobilephone") }}</label>
                  <div class="input-wrapper d-flex align-items-center pos-r">
                    <vue-tel-input
                      class="phone-input padding-right-35px"
                      id="phone-mobile"
                      v-model="kontaktperson.telefonM"
                      :disabled="true"
                      :inputOptions="inputOptions"
                      mode="international"
                    ></vue-tel-input>
                    <div
                      class="call-button pos-a top-0 right-0 bottom-0 d-flex padding-x-10px clickable hover-success"
                      @click="call(kontaktperson.telefonM)"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-phone-arrow-up-right"
                        class="m-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4">
                <div class="form-group">
                  <input
                    v-model.trim="kontaktperson.beziehung.bezeichnung"
                    class="form-control"
                    placeholder=" "
                    :readonly="!editable"
                    :disabled="true"
                  />
                  <label>{{ $t("global.relationshiptype") }}</label>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <ValidationProvider
                    rules="email"
                    immediate
                    v-slot="{ passed }"
                  >
                    <input
                      v-model.trim="kontaktperson.email"
                      type="text"
                      class="form-control"
                      v-bind:class="{ 'border-danger': !passed }"
                      placeholder=" "
                      :disabled="true"
                    />
                    <label v-bind:class="{ 'text-danger': !passed }">{{
                      $t("global.email")
                    }}</label>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-xl-4">
                <div class="form-check">
                  <input
                    type="checkbox"
                    v-model="kontaktperson.einverstaendnisAuskunft"
                    class="form-check-input"
                    :disabled="true"
                  />
                  <label>{{ $t("global.consentinformation") }}</label>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
              {{ $t("global.nocontactperson") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";
import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import AppApi from "@/api/AppApi";

export default {
  name: "GeschaeftspartnerKontaktpersonNewViva",
  components: {
    ContainerHeadline,
    SingleSelectPerson,
  },
  mixins: [],
  props: {
    kontaktperson: {
      type: Object,
      default: function () {
        return {};
      },
    },
    editable: {
      type: Boolean,
      required: true,
    },
    gpId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      person: {
        id: null,
        personName: null,
      },
    };
  },
  computed: {
    inputOptions() {
      return { placeholder: this.$t("global.enteraphonenumber") };
    },
    laender() {
      if (this.$store) return this.$store.state.laender;
      return [];
    },
  },
  created() {},
  watch: {
    kontaktperson: {
      handler(newVal) {
        this.person.id = newVal.id;
        this.person.personName = `${newVal.vorname} ${newVal.name}`;
      },
    },
  },
  mounted() {},
  methods: {
    setPerson(person) {
      AppApi.put(
        "relation/mit/",
        {},
        {
          params: {
            gpIdAlt: this.kontaktperson.id,
            gpIdNeu: person.id,
            relationMitId: this.gpId,
            relationstypId: this.kontaktperson.beziehung.id,
          },
        }
      )
        .then(() => {
          this.$emit("gpReload");
          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: "Neue Kontaktperson erfolgreich verknüpft",
          });
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        });

      this.person = person;
    },
  },
};
</script>

<style></style>
